__turbopack_context__.v({
  "inputLabel": "styles-module-scss-module__BI_RhG__inputLabel",
});
